<template>
	<modal body-classes="p-0" :show="open" @close="close">
		<card type="secondary" class="border-0 mb-0">
			<template slot="header">
				<h2 class="text-center mb-0">
					เพิ่มบัญชี
				</h2>
			</template>
			<template>
				<form @submit.prevent="requestOTP">
					<div v-if="step === 'first'">
						<base-input
							label="เลขบัตรประชาชน"
							placeholder="เลขบัตรประชาชน"
							v-model="identification"
						/>
						<base-input label="เลขบัญชี" placeholder="เลขบัญชี" v-model="accountNumber" />
						<base-input
							label="วัน/เดือน/ปีเกิด"
							placeholder="วัน/เดือน/ปีเกิด"
							v-model="birthDate"
							v-mask="'##/##/####'"
						/>
						<base-input label="เบอร์โทรศัพท์" placeholder="เบอร์โทรศัพท์" v-model="phone" />
						<base-input label="PIN" placeholder="PIN" v-model="pin" />
					</div>
					<base-input label="OTP" placeholder="OTP" v-model="otpCode" v-else />

					<base-button native-type="submit" :disabled="loading" v-if="step === 'first'">
						ส่ง OTP
					</base-button>
					<div v-else>
						<base-button :disabled="loading" @click="confirmOTP">
							บันทึกข้อมูล
						</base-button>
						<base-button type="dark" @click="step = 'first'">
							กรอกข้อมูลใหม่
						</base-button>
					</div>
				</form>
			</template>
		</card>
	</modal>
</template>

<script>
import { Select, Option } from 'element-ui'

import { random } from '../../util/url'
import { mapGetters } from 'vuex'
import SettingService from '../../services/setting.service'

export default {
	props: ['open'],
	components: {
		[Select.name]: Select,
		[Option.name]: Option,
	},
	data() {
		return {
			step: 'first',
			identification: '',
			accountNumber: '',
			birthDate: '',
			phone: '',
			pin: '',
			otpCode: '',
			deviceID: '',

			loading: false,
		}
	},
	methods: {
		close() {
			this.$emit('close')
		},
		async requestOTP() {
			try {
				this.loading = true
				const res = await SettingService.requestAddSCB({
					identification: this.identification,
					accountNumber: this.accountNumber,
					birthDate: this.birthDate,
					phone: this.phone,
					pin: this.pin,
				})

				// prepare for next step
				this.step = 'otp'
				this.deviceID = res.data.deviceID

				this.$notify({ type: 'success', message: res.message })
			} catch ({ message }) {
				this.$notify({ type: 'danger', message })
			} finally {
				this.loading = false
			}
		},
		async confirmOTP() {
			try {
				this.loading = true
				const res = await SettingService.confirmAddSCB(this.deviceID, {
					accountNumber: this.accountNumber,
					pin: this.pin,
					otpCode: this.otpCode,
				})

				// clear data
				this.otpCode = ''

				this.$notify({ type: 'success', message: res.message })
				this.$emit('close')
				this.$emit('reload')
			} catch ({ message }) {
				this.$notify({ type: 'danger', message })
			} finally {
				this.loading = false
			}
		},
	},
}
</script>
